/**
 * A function that takes an array of class names and returns a string of class names.
 *
 * @param {Array<string>} classNames - An array of class names.
 * @returns {string} - A string of class names.
 */
export default (classNames) => classNames.join(` `)
